export default __webpack_public_path__ + "static/media/remove.302c2239.svg";